import { Button, List, Skeleton, Modal } from "antd";
import React, { useState, useEffect } from "react";
import request from "superagent";
import { isEmpty, flattenDeep } from "lodash";
import { getLogsString } from "./logs";
import { getAuthHeader } from "../../utils/superagent";
import { isDefined } from "@clipboard-health/util-ts";

const count = 2;

function ProfileChangeLogsCard({ id }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [logs, setLogs] = useState<any[]>([]);
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [list, setList] = useState<any[]>([]);
  const [showLogs, setShowLogs] = useState(false);
  const [isInitialLoading, setInitialLoading] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [totalCount, setTotalCount] = useState<number>();

  useEffect(() => {
    if (!skip) {
      return;
    }
    void fetchData((result) => {
      const data = logs.concat(result);
      setLogs(data);
      setList(data);
      setLoading(false);
      window.dispatchEvent(new Event("resize"));
    });
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip]);

  const handleShowProfileLogs = async () => {
    setInitialLoading(true);

    void request
      .get(`${global.api}/profileChangeLogs/count`)
      .query({ id })
      .set(await getAuthHeader())
      .then(({ body }) => {
        setTotalCount(body.count);
      });

    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line @typescript-eslint/no-shadow
    void fetchData((logs) => {
      setLogs(logs);
      setList(logs);
      setShowLogs(true);
      setInitialLoading(false);
    });
  };

  const fetchData = async (callback) => {
    void request
      .get(`${global.api}/profileChangeLogs`)
      .query({ id, skip })
      .set(await getAuthHeader())
      .then(({ body }) => {
        const formattedLogs = body.logs.map((log) => getLogsString({ log })).filter((log) => log);
        callback(flattenDeep(formattedLogs));
      });
  };

  if (!showLogs) {
    return (
      <Button onClick={handleShowProfileLogs} loading={isInitialLoading}>
        Show Profile Change Logs
      </Button>
    );
  }

  const onLoadMore = () => {
    setLoading(true);
    const listWithLoading = logs.concat(Array.from({ length: count }, () => ({ loading: true })));
    setList(listWithLoading);
    setSkip(skip + 10);
  };

  const handleOnclose = () => {
    setShowLogs(false);
    setSkip(0);
    setTotalCount(0);
    setLogs([]);
    setList([]);
  };

  const renderItem = (item) => (
    <List.Item>
      <Skeleton loading={item.loading} active>
        {item}
      </Skeleton>
    </List.Item>
  );

  const hasMore = isDefined(totalCount) && totalCount > logs.length;

  const loadMore =
    !isLoading && hasMore ? (
      <div
        style={{
          textAlign: "center",
          marginTop: 12,
          height: 32,
          lineHeight: "32px",
        }}
      >
        <Button onClick={onLoadMore}>Load more</Button>
      </div>
    ) : null;

  return (
    <Modal
      title="Profile Changes"
      visible={showLogs}
      onCancel={handleOnclose}
      width={1200}
      bodyStyle={{
        maxHeight: 700,
      }}
      footer={null}
    >
      <div
        style={{
          maxHeight: 500,
          overflowY: isEmpty(logs) ? "unset" : "scroll",
        }}
      >
        <List size="small" dataSource={list} loadMore={loadMore} renderItem={renderItem} />
      </div>
    </Modal>
  );
}

export { ProfileChangeLogsCard };
